import { Deserializable } from '../protocols/deserializable';

export class VbAccountUpcomingPayment implements Deserializable {
  public paymentType!: string;
  public date!: string;
  public amount!: number;

  public onDeserialize(): void {}
}
